import { render, staticRenderFns } from "./AddElementList.vue?vue&type=template&id=6eaa4612&scoped=true&"
import script from "./AddElementList.vue?vue&type=script&lang=js&"
export * from "./AddElementList.vue?vue&type=script&lang=js&"
import style0 from "./AddElementList.vue?vue&type=style&index=0&id=6eaa4612&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eaa4612",
  null
  
)

export default component.exports